import  { useState, useEffect } from "react";
import {
  FaInstagram,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
} from "react-icons/fa";
import { SiTiktok } from "react-icons/si";
import "./socialfloatingmenu.css";

const SocialFloatingMenu = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth <= 991) {
        if (window.scrollY > 300) {
          setVisible(false);
        } else {
          setVisible(true);
        }
      } else {
        // En pantallas grandes siempre visible.
        setVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  return (
    <div
      className="social-floating-menu"
      style={{ opacity: visible ? 1 : 0, transition: "opacity 300ms ease" }}
    >
      <div className="social-icons">
        <a
          href="https://www.instagram.com/workingunidos"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="social-icon">
            <FaInstagram />
          </div>
        </a>
        <a
          href="https://www.facebook.com/workingunidos"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="social-icon">
            <FaFacebookF />
          </div>
        </a>
        <a
          href="https://www.tiktok.com/@workingunidos"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="social-icon">
            <SiTiktok />
          </div>
        </a>
        <a
          href="https://x.com/workingunidos"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="social-icon">
            <FaTwitter />
          </div>
        </a>
        <a
          href="https://www.linkedin.com/company/workingunidos/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="social-icon">
            <FaLinkedinIn />
          </div>
        </a>
      </div>
    </div>
  );
};

export default SocialFloatingMenu;